module.exports = __webpack_public_path__ + "img/fig_dofa.de219ec0.svg";